export const GENERAL_MODULE_NAME = 'publicDocument';
